// extracted by mini-css-extract-plugin
module.exports = {"socialSection":"socialbar-module--socialSection--3SBJ0","socialLogo":"socialbar-module--socialLogo--22vbA"};